import React from 'react';
import { Info } from 'lucide-react';
import {
  LSC_BILLING_UI_DISABLED_MESSAGE,
  LSC_CHECKOUT_UNAVAILABLE_COPY,
} from '../billingCopy';

interface BillingDisabledBannerProps {
  variant?: 'checkout' | 'ui';
  /** Lifecycle-aware customer message; overrides variant default when set. */
  message?: string;
}

const BillingDisabledBanner: React.FC<BillingDisabledBannerProps> = ({
  variant = 'checkout',
  message,
}) => {
  const resolvedMessage =
    message ||
    (variant === 'ui' ? LSC_BILLING_UI_DISABLED_MESSAGE : LSC_CHECKOUT_UNAVAILABLE_COPY);

  return (
    <div
      className="rounded-lg border border-secondary-600 bg-secondary-800/80 px-4 py-3 text-sm text-secondary-200"
      data-testid="lsc-billing-disabled-banner"
      role="status"
    >
      <div className="flex items-start gap-2">
        <Info className="h-4 w-4 text-primary-400 mt-0.5 shrink-0" aria-hidden />
        <p>{resolvedMessage}</p>
      </div>
    </div>
  );
};

export default BillingDisabledBanner;
